import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, MessageCircle } from "lucide-react";

// In-app inbox of WABA alerts targeted at the current user (student/staff).
export default function AlertsInbox() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/waba/my-alerts").then(r => setRows(r.data)).catch(() => setRows([])); }, []);
  if (rows === null) return <div className="nb-card p-6">Loading alerts…</div>;
  return (
    <div className="space-y-4" data-testid="alerts-inbox">
      <div>
        <h2 className="display text-2xl font-bold flex items-center gap-2"><Bell size={22} /> Alerts &amp; Notifications</h2>
        <p className="text-sm opacity-70">WhatsApp alerts sent to you by your school &amp; Ponderr.</p>
      </div>
      {rows.length === 0 ? (
        <div className="nb-card p-8 text-center bg-white" data-testid="alerts-empty">
          <MessageCircle size={32} className="mx-auto opacity-40" />
          <p className="mt-2 text-sm opacity-70">No alerts yet. New WhatsApp announcements will appear here.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">
          {rows.map(a => (
            <div key={a.id} className="nb-card p-4 bg-white space-y-1" data-testid={`alert-card-${a.id}`}>
              <div className="flex items-center justify-between">
                <span className="nb-badge bg-[#C4B5FD] text-xs">{a.display_name || a.template}</span>
                <span className="nb-badge bg-[#86EFAC] text-[10px]">{a.status === "SIMULATED" ? "Delivered" : a.status}</span>
              </div>
              <div className="text-sm break-words">{(a.body || []).join(" · ")}</div>
              <div className="text-xs opacity-50">{(a.created_at || "").slice(0, 16).replace("T", " ")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
